/**
 * Default pricing screen: the platform per-channel default prices (the tariff
 * applied when an account has none) plus the preset tariffs (rate plans) CRUD.
 */

import React from "react";
import { Box } from "@mui/material";
import { TariffsManager } from "@/features/pricing";
import DefaultPricingList from "./DefaultPricingList";

export const DefaultPricingPage: React.FC = () => (
  <Box>
    <DefaultPricingList />
    <TariffsManager />
  </Box>
);

export default DefaultPricingPage;
